import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { colors } from '../theme';

const navItems = [
  { path: '/home', label: 'Home', emoji: '🏠' },
  { path: '/my-jobs', label: 'My Jobs', emoji: '📋' },
  { path: '/profile', label: 'Profile', emoji: '👤' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: colors.surface,
        borderTop: `1px solid ${colors.divider}`,
        display: 'flex',
        zIndex: 100,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {navItems.map((item) => {
        const active = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px 0 8px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              gap: 2,
            }}
          >
            <span style={{ fontSize: 22, lineHeight: 1 }}>{item.emoji}</span>
            <span
              style={{
                fontSize: 11,
                fontWeight: active ? 700 : 400,
                color: active ? colors.primary : colors.textSecondary,
                fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
              }}
            >
              {item.label}
            </span>
            {active && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  width: 32,
                  height: 3,
                  borderRadius: '0 0 3px 3px',
                  background: colors.primary,
                }}
              />
            )}
          </button>
        );
      })}
    </nav>
  );
}
